import React from "react";

function Upcoming() {
  return (
    <div className="upcomming">
      <div className="container">
        <div className="upcomming-one">
          <span>Creazy deals</span>
          <h3>buy 1 get 1 free</h3>
          <p>The best classic dress is on sale at cara</p>
          <a href="#j">Learn More</a>
        </div>
        <div className="upcomming-two">
          <span>Spring/Summer</span>
          <h3>upcomming season</h3>
          <p>The best classic dress is on sale at cara</p>
          <a href="#j">Collection</a>
        </div>
      </div>
    </div>
  );
}

export default Upcoming;
